import React from 'react';
import Hero from './Hero';

function App() {
  return (
    <div className="min-h-screen bg-black text-white">
      
  <Hero />
    </div>
  );
}

export default App;
